import './http-interceptor/http-interceptor.factory';

import './authentication/authentication.factory';

import './preventTemplateCache/preventTemplateCache.factory';

import './http-request-timeout-interceptor/http-request-timeout-interceptor.factory';